import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { Language } from 'src/app/model/language';
import { LanguageEnum } from 'src/app/model/enum/language-enum';
import { LoginSceneComponent } from '../login/login-scene/login-scene.component';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, TranslocoModule, LoginSceneComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class AuthLayoutComponent {
  @ViewChild(LoginSceneComponent) scene?: LoginSceneComponent;
  @Input() variant: 'scene' | 'split' = 'scene';
  @Input() headline = '';
  @Input() tagline = '';
  @Input() step?: number;
  @Input() stepCount?: number;
  @Input() languages: Language[] = [];
  @Input() currentLanguage?: Language;
  @Output() languageChange = new EventEmitter<Language>();

  readonly languageLabels: Record<string, string> = {
    [LanguageEnum.PT_BR]: 'Português',
    [LanguageEnum.EN_US]: 'English',
    [LanguageEnum.ES_ES]: 'Español',
  };

  get stepSegments(): boolean[] {
    if (!this.step || !this.stepCount) return [];
    return Array.from({ length: this.stepCount }, (_, i) => i < this.step!);
  }
}
